var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('BaseNavItem',{attrs:{"title":_vm.$t('title'),"icon":_vm.$vuetify.icons.values.home,"route":_vm.targetRoute}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }